import {notice} from "/assets/js/utils/notices";
import {nsFetch} from "/assets/js/utils/fetch";

class AccountOrder {
    mainContainer;
    repeatOrderBtn;
    headerCart;

    constructor(elm) {
        this.mainContainer = elm;
        this.repeatOrderBtn = this.mainContainer.querySelector('#repeat-order');
        this.headerCart = document.querySelector('.header__actions-cart');

        this.init();
    }

    init() {
        this.repeatOrderBtn.addEventListener('click', this.clickRepeatOrder);
    }

    clickRepeatOrder = async (e) => {
        e.preventDefault();
        const btn = e.target.closest('#repeat-order');

        btn.classList.add('is-loading');

        const data = {
            'order_id': btn.dataset.orderId,
        };

        const response = await nsFetch.doFetch({
            action: 'ns_repeat_order',
            body: data
        });

        if (!response.success) {
            notice(
                response.data.message,
                'error'
            );
        } else {
            notice(
                response.data.message,
                'success'
            );

            if (response.data.total_count > 99) {
                this.headerCart.dataset.cartCount = '99+';
                this.headerCart.classList.add('nine-nine-plus');
            } else {
                this.headerCart.dataset.cartCount = response.data.total_count;
                this.headerCart.classList.remove('nine-nine-plus');
            }
        }

        btn.classList.remove('is-loading');
    }
}


document.addEventListener('DOMContentLoaded', () => {
    const elm = document.querySelector('.account-page-order');
    if (elm) {
        new AccountOrder(elm);
    }
});



